import { put, call, takeLatest } from 'redux-saga/effects';
import { ClientType } from 'domain/types/client.type';
import { fetchClientsSuccessAction, fetchClientsFailureAction } from 'domain/actions/client.action';
import { showLoading, hideLoading } from 'domain/actions/loading.action';
import { getClients } from 'service/client/client.service';
import { ClientModel } from 'model/client/client.model';

/**
 * Saga worker function to fetch clients
 */
function* fetchClientsSaga() {
  try {
    // Show loading indicator
    yield put(showLoading());
    
    // Call the API service
    const clients: ClientModel[] = yield call(getClients);
    
    // Dispatch success action with the fetched clients
    yield put(fetchClientsSuccessAction(clients));
  } catch (error: any) {
    // Dispatch failure action with the error message
    yield put(fetchClientsFailureAction(error?.message || 'Failed to fetch clients'));
  } finally {
    // Hide loading indicator
    yield put(hideLoading());
  }
}

/**
 * Client saga watcher
 */
export function* clientSaga() {
  // Watch for the fetch clients request action
  yield takeLatest(ClientType.FETCH_CLIENTS_REQUEST, fetchClientsSaga);
}